import * as Yup from "yup";
import {
    dateCantBeInFuture,
    dateIsBefore
} from "./validationFunctions";

export const discloseSensitiveInfoValidations = section => {
    // if (section.active) {
    return Yup.object().shape({

        sensitiveInfo: Yup.array()
            .required(
                () =>
                    'Please specify your preference for the release of sensitive information'
            ),


        // dosfrom: Yup.date()
        //   .required(
        //     () =>
        //       section.fields.dosfrom.validations.required.value &&
        //       section.fields.dosfrom.validations.required.message
        //   ).nullable()
        //   .max(
        //     dateCantBeInFuture,
        //     section.fields.dosfrom.validations.notFutureDate.message
        //   )
        //   .test(
        //     "dosfrom",
        //     section.fields.dosfrom.validations.notFutureDate.message,
        //     function(date){
        //       var todaysDate = new Date();
        //       var enteredDate = new Date(date);
        //       return todaysDate > enteredDate;
        //     }
        //   ),
        // dosto: Yup.date()
        //   .required(
        //     () =>
        //       section.fields.dosto.validations.required.value &&
        //       section.fields.dosto.validations.required.message
        //   ).nullable()
        //   .max(
        //     dateCantBeInFuture,
        //     section.fields.dosto.validations.notFutureDate.message
        //   )
        //   .test(
        //     "afterFromDate",
        //     section.fields.dosto.validations.notBeforeDate.message,
        //     function(dosto) {
        //       const { dosfrom } = this.parent;
        //       if (dosfrom && dosto) {
        //         return dateIsBefore(dosfrom, dosto);
        //       }
        //     }
        //   )
        //   .test(
        //     "afterFromDate",
        //     section.fields.dosto.validations.notFutureDate.message,
        //     function(date){
        //       var todaysDate = new Date();
        //       var enteredDate = new Date(date);
        //       return todaysDate > enteredDate;
        //     }
        //   ),
        // infoToReleaseGroup: Yup.array()
        //   .required(
        //     () =>
        //     section.fields.infoToReleaseGroup.validations.required.value &&
        //     section.fields.infoToReleaseGroup.validations.required.message
        //   ),

        // excludeHIV: Yup.string().when("excludepsy", {
        //   is: val => val.length === 0,
        //   then: Yup.string().required(
        //     "Sensitive Info Error"
        //   )
        //   }),


        // infoToReleaseGroupOther: Yup.string()
        // .test(
        //   "infoToReleaseGroupOther",
        //   section.fields.infoToReleaseGroupOther.validations.required.message,
        //   function(item) {

        //     const { infoToReleaseGroup } = this.parent;
        //     if(infoToReleaseGroup.includes("otherItem"))
        //       return item && infoToReleaseGroup.includes("otherItem");
        //     else return true;
        //   }
        // )
        // .max(
        //   section.fields.infoToReleaseGroupOther.validations.maxLength
        //     .value,
        //   section.fields.infoToReleaseGroupOther.validations.maxLength
        //     .message
        // )
    });
    // }
}
